import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  Divider,
} from '@mui/material';
import { useAppBar } from '../../providers/AppBarProvider';
import { handleError, formatCurrency, formatDate2 } from '../../utils/lib';
import { useLocation, useNavigate } from 'react-router-dom';
import ViewPage from './ViewPage';
import { useSnackbar } from "../../providers/SnackBarProvider";
import axios from 'axios';
import { useTranslation } from 'react-i18next';

function ViewProviderDebts() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const [id, setId] = useState(location.state.id);
  const [name, setName] = useState(location.state.name);
  const [thumb_url, setThumbUrl] = useState(location.state.thumb_url);
  const [providerDebts, setProviderDebts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const {updateTitle} = useAppBar();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = {
          id_provider: id,
          provider_debt_details: '',
        };
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}finance`,
          { params: params, withCredentials: true },
        );
        setProviderDebts(response.data.data);
        updateTitle(thumb_url || '', t('view.providerDebtsPageTitle'), name);
      } catch (error) {
        handleError(error, snackbar);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [t]);

  const handleDebtClick = (debt) => {
    navigate('/main/view-purchase', { state: { id: debt.id } });
  };

  return (
    <ViewPage 
      isLoading={isLoading}
    >
      <Box sx={{ px: 1 }}>
        <List>
          {providerDebts.map((debt, index) => (
            <React.Fragment key={debt.id}>
              <ListItem
                onClick={() => handleDebtClick(debt)}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  py: 2,
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: 'action.hover',
                  },
                }}
              >
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  width: '100%',
                  mb: 1
                }}>
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      {formatDate2(debt.date)}
                    </Typography>
                    {debt.receipt && (
                      <Typography variant="body2" color="text.secondary">
                        {t('view.receiptLabel')} {debt.receipt}
                      </Typography>
                    )}
                    {debt.provider && (
                      <Typography variant="body2" color="text.secondary">
                        {t('view.invoiceTo', { name: debt.provider.name })}
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ textAlign: 'right' }}>
                    <Typography variant="body2" color="text.secondary">
                      {t('view.totalLabel')} {formatCurrency(debt.total)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {t('view.balanceLabel')} {formatCurrency(debt.balance)}
                    </Typography>
                  </Box>
                </Box>
              </ListItem>
              {index < providerDebts.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Box>
    </ViewPage>
  );
}

export default ViewProviderDebts; 